// extracted by mini-css-extract-plugin
module.exports = {"link":"_1h7GdK3EwTGFxMdz65bzm7","arrowLeft":"Qw1eGfb5Lpx8P2i9VIWsF","arrowRight":"_1Hgs47S0b51ehoOC0yTuU2"};